import { useEffect, useState } from 'react';
import './styles.css'
import { Button, CircularProgress, Typography } from '@mui/material';
import { sxSubtitle, sxButtonConsultar } from './sxProps';
import { base64toBlob } from '../../../utils/Base64ToBlob';
import LoadingApp from '../../../components/LoadingApp';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { getVerifUsrCandid } from '../../../services/ContratoService';
import { getRelatorioDeclaracaoPermanencia } from '../../../services/RelatorioService';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import CircularProgressLoading from '../../../components/Accessibility/CircularProgressLoading';
import AudioLoadingDescription from '../../../components/Accessibility/AudioLoadingDescription';
import PageTitle from '../../../components/Accessibility/PageTitle';

function DeclaracaoPermanencia() {

  const [isLoadingPdf, setLoadingPdf] = useState<boolean>(false);
  const [isLoadingPage, setLoadingPage] = useState<boolean>(true);
  const [isRelatorioPermitido, setRelatorioPermitido] = useState<boolean>(true);
  const [msgNaoPermitido, setMsgNaoPermitido] = useState<string>('');
  const [modalFeedback, setmodalFeedback] = useState<null | { icon?: 'error' | 'success', title?: string, textButton?: string, subTitle?: string, action: () => void }>(null);

  const accessibility = useAccessibility();

  useEffect(() => {
    setLoadingPage(true);
    getVerifUsrCandid()
      .then(response => {
        setRelatorioPermitido(response.permitido);
        if (!response.permitido) {
          setMsgNaoPermitido(response.mensagem);
        }
      })
      .catch(error => {
        setmodalFeedback({
          icon: 'error',
          title: 'Erro ao buscar dados',
          subTitle: error.response?.mensagem ? error.response?.data?.mensagem : 'Erro ao consultar permissão',
          textButton: 'Fechar',
          action: () => setmodalFeedback(null)
        })

      })
      .finally(() => {
        setLoadingPage(false);
      })
  }, []);

  const gerarDeclaracao = () => {
    setLoadingPdf(true);
    getRelatorioDeclaracaoPermanencia()
      .then(pdf => {
        const blob = base64toBlob(pdf);
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl);
      })
      .catch(error => {
        console.log({ error })
        setmodalFeedback({
          icon: 'error',
          title: 'Erro ao buscar dados',
          subTitle: error.response?.data?.mensagem ? error.response?.data?.mensagem : 'Erro ao gerar declaração de permanência',
          textButton: 'Fechar',
          action: () => setmodalFeedback(null)
        })
      })
      .finally(() => {
        setLoadingPdf(false);
      })
  }

  return (
    <div className='container'>
      <AudioLoadingDescription loading={isLoadingPage}/>
      <LoadingApp showLoading={isLoadingPdf} />
      <ModalFeedBack
        showModal={modalFeedback ? true : false}
        icon={modalFeedback?.icon as 'success' | 'error'}
        textButton={modalFeedback?.textButton as string}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        handleShowModal={modalFeedback?.action}
        showButtonModal
        handleButtonModal={modalFeedback?.action}
      />
      <PageTitle text="Declaração de permanência" marginBottom="15px" />
      <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxSubtitle, marginBottom: '25px' }}>Aqui você pode retirar o documento contendo informações do seu contrato para processos de Negociação de Carências em outras operadoras de saúde.</Typography>
      <div className="content-container">
        {isLoadingPage &&
            <CircularProgressLoading />
        }
        {
          !isLoadingPage &&
          <>
            {!isRelatorioPermitido && <Typography sx={{ ...sxSubtitle, marginBottom: '25px' }}>
              {msgNaoPermitido ? `Não é possível gerar declaração de permanência: ${msgNaoPermitido}` : `Esta funcionalidade não está disponível para o seu cartão.`}
            </Typography>}
            <Button
              disabled={!isRelatorioPermitido}
              variant='contained' sx={sxButtonConsultar}
              onClick={gerarDeclaracao}
              style={accessibility.buttonStyleAccessibility}
              aria-label="Gerar declaração de permanência"
            >
              <Typography style={accessibility.buttonTextStyleAccessibility}>Gerar Declaração</Typography>
            </Button>
          </>
        }
      </div>
    </div>
  )
}

export default DeclaracaoPermanencia